<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="(key) => toShow(key)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class AlignMenus extends Vue {
        get menuList() {
            return {
                // container: "",
                list: [
                    { key: "change", label: this.$t("change"), showVip: !this.vip },
                    { key: "lift", label: this.$t("lift"), showVip: !this.vip },
                ],
            };
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        toShow(type) {
            this.$store.commit("setStatus", {
                type: "showCryptModal",
                data: true,
            });
            this.$store.commit("setStatus", {
                type: "cryptType",
                data: type,
            });
            this.closeDrop();
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "change": "修改密码",
    "lift": "解除加密"
  },
  "en": {
    "change": "Change Password",
    "lift": "Remove Encryption"
  },
  "fr": {
    "change": "Changer le mot de passe",
    "lift": "Déchiffrer"
  },
  "de": {
    "change": "Passwort ändern",
    "lift": "Passwort entschlüsseln"
  },
  "jp": {
    "change": "パスワードの変更",
    "lift": "ファイルの暗号化を解除"
  },
  "es": {
    "change": "Cambia la contraseña",
    "lift": "Desencriptar"
  },
  "pt": {
    "change": "Mudar senha",
    "lift": "Remover criptografia"
  },
  "it": {
    "change": "Cambia la password",
    "lift": "Rimuovere la crittografia"
  },
  "tw": {
    "change": "修改密碼",
    "lift": "解除加密"
  }
}
</i18n>
